/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { compose } from 'recompose';
import {
    object, shape, string, func, array, bool, arrayOf, number,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

// helper
import { connect, useDispatch } from 'react-redux';
import subscriptionConfig from '../../../../../helpers/common/subscription/subscription-helpers';
import {
    capitalize,
} from './Helper';

// UI
import DiscoverySubscription from './Discovery';
import BasicSubscription from './Basic';
import AbVariantSubscription from './AbVariant';
import  { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getBaseCode } from '../../../../../helpers/tracking/product/dataLayerProductHelpers';
import { getActiveABTests } from '../../../../../../state/ducks/App/ducks/ABTesting/ABTesting-Selectors';
import VariantSubscriptionBox from './VariantSubscriptionBox';
import CollapsableSubscription from './CollapsableSubscription';
import { getFeatureFlag } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const styles = (theme) => ({
    subscriptionContainer: {
        boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
        borderRadius: '4px',
        padding: '9px 0px 9px 10px',
        [theme.breakpoints.down('sm')]: {
            padding: '0 10px',
        },
        [theme.breakpoints.up('1225')]: {
            flexWrap: 'nowrap',
        },
    },
    subscriptionDiscoveryContainer: {
        border: `1px solid ${(theme.palette.grey8)}`,
        borderRadius: '4px',
        padding: '9px 0px 9px 10px',
        [theme.breakpoints.down('sm')]: {
            padding: '9px 5px',
        },
    },
    variantSubscribeBox: {
        padding: 0,
    },
    marginBottom15: {
        marginBottom: '10px',
    },
    subscriptionWrapper: {
        boxShadow: 'none',
        background: '#FAFAFA',
        width: 'calc(100% - 32px)',
        padding: '20px 0px',
        margin: '0 auto',
        [theme.breakpoints.up('600')]: {
            width: '100%',
            padding: '20px 8px',
        },
    },
    subscriptionPdp: {
        marginBottom: '16px',
    },
    pdpShortStyle: {
        padding: '16px 0px',
        [theme.breakpoints.up('600')]: {
            padding: '16px 8px',
        },
    },
});
const Subscription = ({
    classes,
    subscriptionDetails,
    subscription,
    triggerSubscriptionCheck,
    brand,
    subscriptionsList, // redux data
    setSubscriptionDetailData,
    selectedSku,
    activeABTests,
    isSubscriptionDurationListEnabled,
    isShowingFrequencyDropdown,
    isABTestingVariant,
    durationActions,
    frequencyActions,
    subscriptionCopyActions,
    partNumber,
    isSubscriptionPdpCollapsed,
    disableMonthOnlyPayFullPdpSubscriptionBanner,
    isPdpRedesignEnabled,
    pdpOfferContent,
    isPdpRedesignShortEnabled,
}) => {
    const {
        subscriptionDuration: productSubscriptionDuration,
        subscriptionFrequency,
    } = subscriptionDetails;
    const {
        isTypeDiscovery,
        subscriptionCheckbox,
    } = subscription;
    const dispatch = useDispatch();

    const { durationValue, setDurationValue } = durationActions;

    const { frequencyValue, setFrequencyValue } = frequencyActions;

    const { subscriptionCopy } = subscriptionCopyActions;

    const subscriptionDuration = selectedSku?.subscriptionsList?.duration?.[0] || productSubscriptionDuration;
    const isMonthOnlyPayFull = selectedSku?.subscriptions?.type === 'MonthOnlyPayFull' && disableMonthOnlyPayFullPdpSubscriptionBanner;
    const isOptimizeABtesting = activeABTests?.subscriptionBox?.type === 'variant';

    if (isMonthOnlyPayFull) return null;

    let pdpReskinStyle = '';
    if (isPdpRedesignShortEnabled) {
        pdpReskinStyle = `${classes.subscriptionWrapper} ${classes.pdpShortStyle}`;
    } else if (isPdpRedesignEnabled) {
        pdpReskinStyle = classes.subscriptionWrapper;
    }
    const setHandleDataWithChangeOrDefault = (subsDuration, intervalFrequency, intervalData, typeOfSubscription) => {
        setSubscriptionDetailData({
            duration: subsDuration,
            subscriptionInterval: intervalFrequency,
            interval: intervalData,
            subscriptionType: capitalize(selectedSku.subscriptionsList?.type?.[0] || '') || typeOfSubscription,
        });
    };

    const handleChange = (event, durationOrFrequency, subscriptionOptionList) => {
        const durationOrFrequencySelectedValue = subscriptionOptionList.filter((item) => item.id === Number(event.target.value));
        dispatch(trackEvent({
            eventCategory: 'subscription',
            eventAction: durationOrFrequency,
            eventLabel: `${durationOrFrequencySelectedValue?.[0]?.value.toLowerCase?.() || ''} | ${getBaseCode(partNumber)}`  || '',
            eventValue: '1',
        }));
        if (durationOrFrequency === 'duration') {
            const selectedDuration = Number(event.target.value);
            setDurationValue(selectedDuration);

            // updating redux
            setHandleDataWithChangeOrDefault(selectedDuration, frequencyValue, selectedSku.subscriptionsList.interval, subscriptionsList?.subscriptionType);
        } else {
            const subscriptionInterval = Number(event.target.value);
            setFrequencyValue(subscriptionInterval);

            // updating redux
            setHandleDataWithChangeOrDefault(durationValue, subscriptionInterval, selectedSku.subscriptionsList.interval, subscriptionsList?.subscriptionType);
        }
    };

    let renderSubscription = '';

    if (isSubscriptionPdpCollapsed) {
        renderSubscription =  (
            <CollapsableSubscription
                subscriptionCopy={subscriptionCopy}
                subscriptionDetailsFrequencyValue={subscriptionFrequency}
                subscriptionDetailsDurationValue={subscriptionDuration}
                subscriptionConfig={subscriptionConfig}
                brand={brand}
                isShowingFrequencyDropdown={isShowingFrequencyDropdown}
                isSubscriptionDurationListEnabled={isSubscriptionDurationListEnabled}
                selectValue={frequencyValue}
                selectedSku={selectedSku}
                handleChange={handleChange}
                durationValue={durationValue}
                subscriptionCheckbox={subscriptionCheckbox}
                triggerSubscriptionCheck={triggerSubscriptionCheck}
                pdpOfferContent={pdpOfferContent}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
                isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
            />
        );
    } else if (isOptimizeABtesting) {
        renderSubscription = isOptimizeABtesting
        && (
            <VariantSubscriptionBox
                subscriptionCopy={subscriptionCopy}
                subscriptionDetailsFrequencyValue={subscriptionFrequency}
                subscriptionDetailsDurationValue={subscriptionDuration}
                subscriptionConfig={subscriptionConfig}
                brand={brand}
                isShowingFrequencyDropdown={isShowingFrequencyDropdown}
                isSubscriptionDurationListEnabled={isSubscriptionDurationListEnabled}
                selectValue={frequencyValue}
                selectedSku={selectedSku}
                handleChange={handleChange}
                durationValue={durationValue}
                subscriptionCheckbox={subscriptionCheckbox}
                triggerSubscriptionCheck={triggerSubscriptionCheck}
            />
        );
    } else {
        renderSubscription = isABTestingVariant === 'VARIANT A'
            ? (
                <AbVariantSubscription
                    subscriptionCopy={subscriptionCopy}
                    subscriptionDetailsFrequencyValue={subscriptionFrequency}
                    subscriptionDetailsDurationValue={subscriptionDuration}
                    subscriptionConfig={subscriptionConfig}
                    brand={brand}
                    isShowingFrequencyDropdown={isShowingFrequencyDropdown}
                    isSubscriptionDurationListEnabled={isSubscriptionDurationListEnabled}
                    selectValue={frequencyValue}
                    selectedSku={selectedSku}
                    handleChange={handleChange}
                    durationValue={durationValue}
                    subscriptionCheckbox={subscriptionCheckbox}
                    triggerSubscriptionCheck={triggerSubscriptionCheck}
                />
            )
            : (
                <BasicSubscription
                    subscriptionCopy={subscriptionCopy}
                    subscriptionDetailsFrequencyValue={subscriptionFrequency}
                    subscriptionDetailsDurationValue={subscriptionDuration}
                    subscriptionConfig={subscriptionConfig}
                    brand={brand}
                    isShowingFrequencyDropdown={isShowingFrequencyDropdown}
                    isSubscriptionDurationListEnabled={isSubscriptionDurationListEnabled}
                    selectValue={frequencyValue}
                    selectedSku={selectedSku}
                    handleChange={handleChange}
                    durationValue={durationValue}
                    subscriptionCheckbox={subscriptionCheckbox}
                    triggerSubscriptionCheck={triggerSubscriptionCheck}
                />
            );
    }

    let containerClass = classes.subscriptionContainer;
    if (isTypeDiscovery) {
        containerClass =  classes.subscriptionDiscoveryContainer;
    }
    return (
        <Grid item xs={12} sm={12} md={12} className={`${classes.marginBottom15} ${isPdpRedesignEnabled ? classes.subscriptionPdp : ''}`}>
            <Grid container className={`${isOptimizeABtesting ? classes.variantSubscribeBox : containerClass} ${pdpReskinStyle}`}>
                {(isTypeDiscovery)
                    ? (
                        <>
                            <DiscoverySubscription
                                subscriptionCopy={subscriptionCopy}
                                subscriptionDetailsFrequencyValue={subscriptionFrequency}
                                subscriptionDetailsDurationValue={subscriptionDuration}
                                subscriptionConfig={subscriptionConfig}
                                subscriptionCheckbox={subscriptionCheckbox}
                                brand={brand}
                            />
                        </>
                    )
                    : renderSubscription}
            </Grid>
        </Grid>
    );
};

const mapStateToProps = (state) => ({
    activeABTests: getActiveABTests(state),
    isSubscriptionPdpCollapsed: getFeatureFlag('is-subscription-pdp-collapsed-enabled')(state),
    disableMonthOnlyPayFullPdpSubscriptionBanner: getFeatureFlag('disable-month-only-pay-full-pdp-subscription-banner')(state),
});

Subscription.propTypes = {
    classes: object.isRequired,
    subscriptionsList: shape({
        duration: arrayOf(
            number,
        ),
        type: arrayOf(
            string,
        ),
        interval: arrayOf(
            number,
        ),
    }),
    subscriptionDetails: shape({
        subscriptionType: string.isRequired,
        subscriptionDuration: string.isRequired,
        subscriptionFrequency: string.isRequired,
        subscriptionDurationKey: string.isRequired,
    }).isRequired,
    subscription: shape({
        subscriptionKey: array.isRequired,
        subscriptionIndefinite: string.isRequired,
        subscriptionType: array.isRequired,
        implementProductSubscription: bool.isRequired,
        viewSubscription: bool.isRequired,
        isTypeDiscovery: bool.isRequired,
        subscriptionCheckbox: bool.isRequired,
    }).isRequired,
    setSubscriptionDetailData: func.isRequired,
    triggerSubscriptionCheck: func.isRequired,
    brand: shape({
        domain: string,
    }).isRequired,

    selectedSku: object.isRequired,
    isSubscriptionDurationListEnabled: bool.isRequired,
    isShowingFrequencyDropdown: bool.isRequired,
    isABTestingVariant: bool.isRequired,
    durationActions: shape({
        durationValue: string.isRequired,
        setDurationValue: func.isRequired,
    }).isRequired,
    frequencyActions: shape({
        frequencyValue: string.isRequired,
        setFrequencyValue: func.isRequired,
    }).isRequired,
    subscriptionCopyActions: shape({
        subscriptionCopy: string.isRequired,
        setSubscriptionCopy: func.isRequired,
    }).isRequired,
    partNumber: string.isRequired,
    activeABTests: object,
    isSubscriptionPdpCollapsed: bool,
    disableMonthOnlyPayFullPdpSubscriptionBanner: bool,
    isPdpRedesignEnabled: bool,
    pdpOfferContent: object,
    isPdpRedesignShortEnabled: bool,
};

Subscription.defaultProps = {
    subscriptionsList: {},
    activeABTests: {},
    isSubscriptionPdpCollapsed: false,
    disableMonthOnlyPayFullPdpSubscriptionBanner: false,
    pdpOfferContent: {},
    isPdpRedesignEnabled: false,
    isPdpRedesignShortEnabled: false,
};
export default compose(
    withStyles(styles),
    connect(mapStateToProps, null),
)(Subscription);
